"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class ConsumptionPrice extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 2.48928, description: 'The tariff value corresponding to the description' }),
    tslib_1.__metadata("design:type", Number)
], ConsumptionPrice.prototype, "amount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Totaal tarief gas (1 t/m 170.000 m3):', description: 'Description of the tariff' }),
    tslib_1.__metadata("design:type", String)
], ConsumptionPrice.prototype, "description", void 0);
exports.default = ConsumptionPrice;
